import React from 'react';
import { ReactComponent as PadlockIcon } from '$/assets/icons/padlock.svg';
import BixButton from '$/components/global/bixButton';
import './index.scss';
import classnames from 'classnames';

interface IGoPrivateButtonProps {
  text: string;
  useWithGrid?: boolean;
  hasIcon?: boolean;
  onClick: () => void;
}

const GoPrivateButton: React.FC<IGoPrivateButtonProps> = ({ onClick, useWithGrid, text, hasIcon }) => {
  return (
    <>
      <BixButton
        className={classnames('go_private_button', { use_with_grid: useWithGrid, text_only: !hasIcon })}
        type="button"
        onClick={onClick}
        useSmall>
        {hasIcon && <PadlockIcon />}
        <div>{text}</div>
      </BixButton>
    </>
  );
};

export default GoPrivateButton;
